// src/utils/jwtUtils.js
import { jwtDecode } from 'jwt-decode';

const TOKEN_KEY = 'authToken';

// Get Token from Local Storage
export const getToken = () => localStorage.getItem(TOKEN_KEY);

// Set Token to Local Storage
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);

// Remove Token from Local Storage
export const removeToken = () => localStorage.removeItem(TOKEN_KEY);

// Check if Token is Valid
export const isTokenValid = (token) => {
    if (!token) return false;

    try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        return decodedToken.exp > currentTime;
    } catch (err) {
        console.error('Invalid Token:', err);
        return false;
    }
};
